import { render, staticRenderFns } from "./PanelIzquierdo.vue?vue&type=template&id=ae9fefb4&"
import script from "./PanelIzquierdo.vue?vue&type=script&lang=js&"
export * from "./PanelIzquierdo.vue?vue&type=script&lang=js&"
import style0 from "./PanelIzquierdo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports